import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  mailPattern: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  urlPattern: RegExp = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/,=]*)$/;


  constructor(
    private translate: TranslateService,
    private readonly toastr: ToastrService,
  ) { }


  public hasTranslation(key: string): boolean {
    let isTranslated: boolean = true;
    if (this.translate.instant(key) == key) {
      isTranslated = false;
    }
    return isTranslated;
  }

  validateEmailPattern(email: string) {
    return this.mailPattern.test(email)
  }

  validateUrlPattern(url: string) {
    return this.urlPattern.test(url)
  }

  /**
   * Whether a URL obviously points inside a network (localhost, a private, loopback or link-local IPv4, an IPv6
   * literal), which the backend refuses to crawl. Only the visible cases: the backend checks what the name resolves to.
   */
  isInternalUrl(url: string): boolean {
    let host: string;
    try {
      host = new URL(url).hostname.toLowerCase();
    } catch {
      return false;
    }
    if (host === 'localhost' || host.endsWith('.localhost') || host.startsWith('[')) {
      return true;
    }
    const v4 = host.match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/);
    if (!v4) {
      return false;
    }
    const [a, b] = [Number(v4[1]), Number(v4[2])];
    return a === 0 || a === 10 || a === 127 || (a === 100 && b >= 64 && b <= 127) || (a === 169 && b === 254)
      || (a === 172 && b >= 16 && b <= 31) || (a === 192 && b === 168);
  }

  /**
   * Toast translated error message of http error responses if possible, falls
   * back to ERRORS.GENERIC otherwise
   */
  toastError(err: unknown): void {
    if (err instanceof HttpErrorResponse && this.hasTranslation(`ERRORS.${err.error?.message}`)) {
      this.toastr.error(this.translate.instant(`ERRORS.${err.error?.message}`));
    } else {
      this.toastr.error(this.translate.instant('ERRORS.GENERIC'));
    }
  }
}
